import { createFileRoute, redirect } from '@tanstack/react-router';

/** A job, or one of its rules, from an old link: Roles, since jobs went (web-redesign-03 phase 2.5). */
export const Route = createFileRoute('/_app/business/jobs/$')({
  beforeLoad: () => {
    throw redirect({ to: '/business/roles', replace: true });
  },
});
